import React from 'react';
import { BOOKING_STATUSES, STATUS_COLORS, PENDING_COLORS, STATUS_LABELS } from '../../constants/statuses';

const CalendarLegend = ({
  unavailableDatesEnabled = false,
  wwooferInitiatedEnabled = false,
  selectedStatuses = [],
  onStatusChange
}) => {
  const isClickable = typeof onStatusChange === 'function';

  // Custom legend items that show both pending colors
  const legendItems = [
    { color: PENDING_COLORS.HOST_INITIATED, label: 'Pending (Host Request)', status: BOOKING_STATUSES.PENDING },
    ...(wwooferInitiatedEnabled ? [{ color: PENDING_COLORS.WWOOFER_INITIATED, label: 'Pending (WWOOFer Request)', status: BOOKING_STATUSES.PENDING }] : []),
    { color: STATUS_COLORS[BOOKING_STATUSES.ACCEPTED], label: STATUS_LABELS[BOOKING_STATUSES.ACCEPTED], status: BOOKING_STATUSES.ACCEPTED },
    { color: STATUS_COLORS[BOOKING_STATUSES.IN_PROGRESS], label: STATUS_LABELS[BOOKING_STATUSES.IN_PROGRESS], status: BOOKING_STATUSES.IN_PROGRESS },
    { color: STATUS_COLORS[BOOKING_STATUSES.COMPLETED], label: STATUS_LABELS[BOOKING_STATUSES.COMPLETED], status: BOOKING_STATUSES.COMPLETED },
    { color: STATUS_COLORS[BOOKING_STATUSES.CANCELLED], label: STATUS_LABELS[BOOKING_STATUSES.CANCELLED], status: BOOKING_STATUSES.CANCELLED },
  ];

  const handleToggle = (status) => {
    if (!isClickable) return;
    const newStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter(s => s !== status)
      : [...selectedStatuses, status];

    onStatusChange(newStatuses);
  };

  return (
    <div className="calendar-legend">
      <div className="legend-items">
        {legendItems.map((item, index) => {
          const isActive = selectedStatuses.includes(item.status);
          const classNames = ['legend-item'];

          if (isClickable) {
            classNames.push('legend-item--clickable', isActive ? 'legend-item--active' : 'legend-item--inactive');
          }

          return (
            <button
              key={`${item.status}-${index}`}
              type="button"
              className={classNames.join(' ')}
              onClick={() => handleToggle(item.status)}
              aria-pressed={isClickable ? isActive : undefined}
            >
              <span
                className="legend-color"
                style={{ backgroundColor: item.color }}
              />
              <span className="legend-label">{item.label}</span>
            </button>
          );
        })}
        {unavailableDatesEnabled && (
          <div className="legend-item">
            <div
              className="legend-color legend-color--unavailable"
              style={{ backgroundColor: 'rgba(255, 0, 0, 0.25)', border: '1px solid rgba(255, 0, 0, 0.5)' }}
            />
            <span className="legend-label">Unavailable</span>
          </div>
        )}
      </div>
      {unavailableDatesEnabled && (
        <p className="calendar-legend__unavailability-hint">
          To mark dates as unavailable, click and drag across the days you want to block. Click an existing unavailable period to remove it.
        </p>
      )}
    </div>
  );
};

export default CalendarLegend;
